import { Trip } from './flightSearch';

export interface UpSellResponse {
  upsellOptions: UpSellOption[];
  upsellAvailableUntil: string;
  upsellId: string;
}

export interface UpSellOption {
  amount: UpSellAmount;
  amountAlternative?: UpSellAmount;
  families: UpSellFamily[] | UpSellFamily;
  optionId: number;
  isPreApproved?: boolean;
  breakRulesMessage?: string[];
}
interface UpSellAmount {
  currencyCode: string;
  fare: number;
  taxes: number;
}

interface UpSellFamily {
  code: string;
  name: string;
  inclusions: UpSellInclusion[] | UpSellInclusion;
}

export interface UpSellInclusion {
  rowName: string;
  code: string;
  type: UpSellInclusionType | string;
  title?: string;
  subTitle?: string;
  order: number;
}

export enum UpSellInclusionType {
  Included = 'Included',
  AtCharge = 'AtCharge',
  NotOffered = 'NotOffered',
}


export interface UpsellBySectorRequest {
  trips: Trip[];
  searchId: string;
  sessionToken: string;
  userId: string;
  userGroupId: string;
  adults: number;
  lowestLogicalFare: number;
  distanceRestriction: string;
  optionId: number;
  sectorNumber: number;
  previousOptions?:string[];  
}